import React from 'react';
import { Link } from 'react-router-dom';
import type { Product } from '../types';
import { formatCents } from '../utils/money';

interface Props {
  product: Product;
}

const ProductCard: React.FC<Props> = ({ product }) => {
  const cover = product.images?.[0];
  // The product detail page is keyed by product_id. Slug-based pretty URLs
  // can be added later by resolving slug -> product_id on the backend.
  const href = `/shop/${product.product_id}`;
  const inStock = product.in_stock !== false;

  return (
    <Link to={href} className="block group">
      <div className="aspect-square bg-background-dark overflow-hidden rounded">
        {cover ? (
          <img
            src={cover}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-text-light text-sm">
            No image
          </div>
        )}
      </div>
      <div className="mt-3">
        <div className="text-sm font-medium text-text">{product.name}</div>
        <div className="text-sm text-text-light mt-0.5 flex items-center justify-between">
          <span>{product.price_cents > 0 ? formatCents(product.price_cents) : '—'}</span>
          {!inStock && <span className="text-xs uppercase tracking-wide">Sold out</span>}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
